<template>
  <!-- Coming soon page-->
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <logo
        :height="`35px`"
        :full="true"
      />
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ $t('Serviço temporariamente indisponível') }}
        </h2>
        <p class="mb-3">
          {{ $t('Estamos com problemas na ligação aos nossos serviços.') }}
          <br>
          {{ $t('Por favor, tente mais tarde.') }}
        </p>
        <b-img
          fluid
          :src="imgUrl"
        />
      </div>
    </div>
  </div>
<!-- / Coming soon page-->
</template>

<script>
/* eslint-disable global-require */
import {
  BLink, BImg,
} from 'bootstrap-vue'
import logo from '@core-custom/layouts/components/Logo.vue'
import store from '@/store/index'

export default {
  components: {
    logo,
    BLink,
    BImg,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/coming-soon.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/coming-soon-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
